// extracted by mini-css-extract-plugin
export default {"taskContainerWrapper":"tasks_taskContainerWrapper__Y8xOu","taskContainer":"tasks_taskContainer__3K0HD","task":"tasks_task__sAQBV"};